import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { Option } from "@shared/Entities/General/option.entity";
import { CompanyAlly } from "@shared/Interfaces/company-ally.interface";
import { PadronPerson } from "@shared/Interfaces/person";

const { enlineaBackendUrl } = environment;
@Injectable({
  providedIn: "root",
})
export class SharedOptionsRepository {
  constructor(private http: HttpClient) {}

  @Cacheable()
  public getSexs(): Observable<Option[]> {
    return of([
      {
        codigo: "M",
        nombre: "Masculino",
      },
      {
        codigo: "F",
        nombre: "Femenino",
      },
    ]);
  }

  @Cacheable()
  public getMaritalStatus(): Observable<Option[]> {
    return of([
      {
        codigo: "S",
        nombre: "Soltero",
      },
      {
        codigo: "C",
        nombre: "Casado",
      },
    ]);
  }

  public getPersonByIdentification(identification: string): Observable<PadronPerson> {
    return this.http.get<PadronPerson>(`${enlineaBackendUrl}/${identification}`);
  }

  @Cacheable()
  public getIdentificationTypes(): Observable<Option[]> {
    return this.http.get<Option[]>(`${enlineaBackendUrl}/api/TipoIdentificaciones`);
  }

  @Cacheable()
  public getProvinces(): Observable<Option[]> {
    return this.http.get<Option[]>(`${enlineaBackendUrl}/api/Provincias/ObtenerProvincias`);
  }

  @Cacheable()
  public getCompanyAlly(): Observable<CompanyAlly[]> {
    return this.http.get<CompanyAlly[]>(`${enlineaBackendUrl}/api/unit/Company/aliados`);
  }
}
